import { c as _c } from "react/compiler-runtime";
import { CloseButton } from '@mantine/core';
import { ReactNode } from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { StyleProps, Tip, TipProps, useTip, WrapIf } from 'shared/ui';
import { classes } from './theme/theme';
import { isString } from 'remeda';
import { O } from 'ts-toolbelt';
import { twMerge } from 'tailwind-merge';
import { nav } from './portal/nav';

/** An inline help tip */
export const InfoLabel = t0 => {
  const $ = _c(12);
  const {
    children,
    className,
    helpPath
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge(classes.text.label, "flex gap-2 items-start", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = helpPath != null;
  let t3;
  if ($[2] !== helpPath) {
    t3 = c => <a href={nav.help.url.addPath(helpPath).url} className="flex gap-1 items-start" target="_blank">{c}</a>;
    $[2] = helpPath;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MdInfoOutline className="icon-text mt-[2px] flex-shrink-0" size={14} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t2 || $[7] !== t3) {
    t5 = <WrapIf if={t2} wrap={t3}>{t4}{children}</WrapIf>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <div className={t1}>{t5}</div>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export const InfoTip = t0 => {
  const $ = _c(26);
  let children;
  let className;
  let customStore;
  let hideClose;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      label,
      hideClose,
      children,
      store: customStore,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = customStore;
    $[4] = hideClose;
    $[5] = label;
    $[6] = props;
  } else {
    children = $[1];
    className = $[2];
    customStore = $[3];
    hideClose = $[4];
    label = $[5];
    props = $[6];
  }
  const defaultStore = useTip();
  const store = customStore ?? defaultStore;
  const t1 = children != null;
  let t2;
  if ($[7] !== children || $[8] !== className) {
    t2 = c => <div className={twMerge(["flex items-center gap-1", classes.text.label, className])}>{children}{c}</div>;
    $[7] = children;
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== hideClose || $[11] !== label || $[12] !== store) {
    t3 = !isString(label) && !hideClose && <CloseButton style={{
      position: "absolute"
    }} className="right-1 top-1 z-10" onClick={() => store.setOpened(false)} />;
    $[10] = hideClose;
    $[11] = label;
    $[12] = store;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== label || $[15] !== t3) {
    t4 = <>{label}{t3}</>;
    $[14] = label;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div><MdInfoOutline size="1.3em" className="mr-1" /></div>;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== props || $[19] !== store || $[20] !== t4) {
    t6 = <Tip {...props} store={store} className="relative" withArrow={true} closeOnClickOutside={false} label={t4}>{t5}</Tip>;
    $[18] = props;
    $[19] = store;
    $[20] = t4;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t1 || $[23] !== t2 || $[24] !== t6) {
    t7 = <WrapIf if={t1} wrap={t2}>{t6}</WrapIf>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};